export default "__VITE_ASSET__Be53u_QL__"